import React from 'react';
import './App.css';
import ScheduleView from './components/ScheduleView/ScheduleView';
import { config } from './config';

function App() {
  if (!config.featureFlags.enableApp) {
    return null;
  }

  return (
    <div className='App'>
      <ScheduleView />
    </div>
  );
}

export default App;
